import { Card, CardContent, Alert, AlertTitle, Typography, Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export interface ImportReviewProps {
  importMethod: "csv" | "manual";
  csvFile: File | null;
  previewData: any[];
  manualLeads: any[];
}

export const ImportReview: React.FC<ImportReviewProps> = ({
  importMethod,
  csvFile,
  previewData,
  manualLeads,
}) => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent>
        <Alert severity="success" sx={{ mb: 3 }}>
          <AlertTitle>{t("leads.readyToImport")}</AlertTitle>
          {importMethod === "csv"
            ? `${previewData.length} ${t("leads.willBeImported")}`
            : `${manualLeads.length} ${t("leads.manualWillBeImported")}`}
        </Alert>
        <Typography variant="h6" gutterBottom>
          {t("leads.importSummary")}
        </Typography>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" gutterBottom>
            <strong>Metodo di importazione:</strong>{" "}
            {importMethod === "csv" ? "File CSV" : "Manuale"}
          </Typography>
          {importMethod === "csv" && csvFile && (
            <Typography variant="body1" gutterBottom>
              <strong>File:</strong> {csvFile.name}
            </Typography>
          )}
          <Typography variant="body1">
            <strong>Leads totali:</strong>{" "}
            {importMethod === "csv" ? previewData.length : manualLeads.length}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t("leads.clickImportLeads")}
        </Typography>
      </CardContent>
    </Card>
  );
};
